export const useGetToolbarExtraActions = ({ availableActions, excludedActions }: { availableActions: any[], excludedActions: any[] }) => {
  return availableActions.map(group => group.filter(action => !excludedActions.includes(action.key)))
}
